/**
 * Edition info panel for Manage Subscription Plans.
 * Displays plan ID, creation/update timestamps and responsible admin emails.
 * All dates are displayed in UTC (admin page, backend operates in UTC).
 */
import './edition-info.scss';
import {observer} from 'mobx-react';
import FontBody1 from '../../../../../components/fonts/font-body1/font-body1';
import {FONT_VARIANT} from '../../../../../components/fonts/font-props';
import SubscriptionPlanEditorStore from '../../../stores/subscription-plan-editor-store';
import {useEffect} from "react";
import DateTimeV2, {DATETIME_VIEW} from '../../../../../components/datetime-v2/datetime-v2';

interface IProps {
    store?: SubscriptionPlanEditorStore;
}

const EditionInfo: React.FC<IProps> = observer(({store}) => {

    useEffect(() => {
        store?.fetchEditingStory(store?.id);
    }, [store]);

    const planCreatedEvent = store?.getCreatedByUser();
    const createdAdminEmail = planCreatedEvent?.user_email;

    const planUpdatedEvent = store?.getUpdatedByUser();
    const updatedAdminEmail = planUpdatedEvent?.user_email;

    return <div className='edition-info-container'>
        <span>
            <FontBody1>ID </FontBody1>
            <FontBody1 variant={FONT_VARIANT.BOLD}>{store?.id}
            </FontBody1>
        </span>
        {store?.created_at &&
            <span>
                <FontBody1>Created at </FontBody1>
                <FontBody1 variant={FONT_VARIANT.BOLD}>
                    <DateTimeV2 utcDateString={store.created_at} dateTimeView={DATETIME_VIEW.FULL} timeZone="UTC" />
                </FontBody1>
            </span>
        }
        {store?.updated_at &&
            <span>
                <FontBody1>Updated at </FontBody1>
                <FontBody1 variant={FONT_VARIANT.BOLD}>
                    <DateTimeV2 utcDateString={store.updated_at} dateTimeView={DATETIME_VIEW.FULL} timeZone="UTC" />
                </FontBody1>
            </span>
        }
        {planCreatedEvent && createdAdminEmail &&
            <span>
                <FontBody1>Created at </FontBody1>
                <FontBody1 variant={FONT_VARIANT.BOLD}>
                    <DateTimeV2 utcDateString={planCreatedEvent.created_at} dateTimeView={DATETIME_VIEW.FULL} timeZone="UTC" />
                </FontBody1>
                <FontBody1> by </FontBody1>
                <FontBody1> {createdAdminEmail} </FontBody1>
            </span>
        }
        {planUpdatedEvent && updatedAdminEmail &&
            <span>
                <FontBody1>Updated at </FontBody1>
                <FontBody1 variant={FONT_VARIANT.BOLD}>
                    <DateTimeV2 utcDateString={planUpdatedEvent.updated_at} dateTimeView={DATETIME_VIEW.FULL} timeZone="UTC" />
                </FontBody1>
                <FontBody1> by </FontBody1>
                <FontBody1> {updatedAdminEmail} </FontBody1>
            </span>
        }
    </div>
});

export default EditionInfo;
